import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { decryptData } from "helpers";
import { encryptData } from "helpers";
import { getHeaderConfig } from "helpers";
import { consoleLog } from "helpers";

export const getFilterSysPromptsAPI = async (
  { pageIndex, limit, skip },
  payload,
  setIsLoading,
  accessJWT
) => {
  try {
    setIsLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    consoleLog([payload, "payloadpayloadpayload"]);

    const body = {
      ...payload,
      skip: pageIndex + 1,
      limit: limit || 10,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/prompt/filter`,
      encryptData(body),
      config
    );

    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData?.statusCode === 200) {
      if (setIsLoading) setIsLoading(false);
      return {
        data: parsedResponseData?.data.data,
        totalPages: parsedResponseData.data.pagination?.totalPages,
      };
    }

    throw new Error("Error fetching data");
  } catch (error) {
    console.error("Error fetching data:", error);
    return { data: [], totalPages: 0 };
  } finally {
    setIsLoading(false);
  }
};

export const getSysPromptsAPI = async (
  { pageIndex, skip },
  isLoading,
  accessJWT,
  sysPromptsId = ""
) => {
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    const body = {
      id: sysPromptsId || "",
    };

    const postBody = {
      skip: pageIndex + 1,
      limit: skip || 10,
    };

    let response;
    if (sysPromptsId) {
      response = await axios.post(
        `${ENDPOINT}/app/v1/prompt`,
        encryptData(body),
        config
      );
    } else {
      response = await axios.post(
        `${ENDPOINT}/app/v1/prompt/filter`,
        encryptData(postBody),
        config
      );
    }

    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData && parsedResponseData.statusCode === 200) {
      if (isLoading) isLoading(false);
      return parsedResponseData?.data;
    }
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return null;
  }
};

export const createOrUpdateSysPromptsAPI = async (
  args,
  isLoading,
  accessJWT
) => {
  const API_URL = `${ENDPOINT}/app/v1/prompt `;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = args?.id
      ? await axios.put(API_URL, encryptData({ ...args }), config)
      : await axios.post(API_URL, encryptData({ ...args }), config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (isLoading) isLoading(false);

    if (parsedResponseData?.statusCode === 200) {
      return parsedResponseData?.data;
    } else {
      throw new Error(parsedResponseData?.message || "Unknown error");
    }
  } catch (error) {
    if (isLoading) isLoading(false);
    const message =
      error?.response?.data?.[0]?.message ||
      error?.message ||
      "Something went wrong";
    return { error: true, message };
  }
};

export const deleteSysPromptsAPI = async (args, isLoading, accessJWT) => {
  const API_URL = `${ENDPOINT}/app/v1/prompt?id=${args.id}`;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.delete(API_URL, config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData) {
      if (isLoading) isLoading(false);
      return parsedResponseData;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error deleting system prompt:", error);
    return null;
  }
};

export const getAutoSuggestAPI = async (
  query,
  fieldType,
  isLoading,
  accessJWT
) => {
  try {
    if (isLoading) isLoading(true);

    const body = {
      key: query,
    };
    const queryBody = {
      name: query,
    };

    const url =
      fieldType === "key"
        ? `${ENDPOINT}/app/v1/nameSuggestion`
        : `${ENDPOINT}/app/v1/nameSuggestion`;

    const config = getHeaderConfig(null, accessJWT);

    consoleLog(["Request Headers:", config]);

    const response = await axios.post(
      url,
      fieldType === "key" ? encryptData(body) : encryptData(queryBody),
      config
    );

    const parsedResponseData = JSON.parse(decryptData(response?.data));
    consoleLog(["Parsed Response Data:", parsedResponseData]);

    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      return parsedResponseData?.data;
    }

    throw new Error(
      `Failed to fetch suggestions, Status Code: ${parsedResponseData?.statusCode}`
    );
  } catch (error) {
    console.error("Error fetching auto-suggest data:", error);

    if (error.response) {
      console.error(
        `Response Error: ${error.response.status} - ${error.response.data}`
      );
    }

    if (isLoading) isLoading(false);

    return null;
  } finally {
    if (isLoading) isLoading(false);
  }
};
